export function getKnownUserType(userType) {
  return userType === 'influencer' || userType === 'brand' ? userType : null;
}

export function getUserTypeFromToken() {
  const token = localStorage.getItem('token');
  if (!token) return null;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return getKnownUserType(payload.user_type);
  } catch (error) {
    console.error('Error decoding token in TourProvider:', error);
    return null;
  }
}
